module.exports = __webpack_public_path__ + "static/img/fclab-award.5df744e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/fclab-award.jpg
// module id = GByQ
// module chunks = 0